var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pot-loading"},[_c('span',{staticClass:"pot-loading-spinners",style:(_vm.style)},_vm._l((_vm.balde),function(item){return _c('i',{staticClass:"pot-loading-spinner"})}))])}
var staticRenderFns = []

export { render, staticRenderFns }